import { faArrowLeft, faCircleInfo, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, Form, Input, Row, Space } from "antd"
import { useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"

const AppointmentDetailSchedule = () => {
    const Navigate = useNavigate();
    const [contact, SetContact] = useState(false);
    const [details, SetDetails] = useState(false);

    const EditContact = () => {
        SetContact(!contact);
    }

    const EditDetails = () => {
        SetDetails(!details);
    }

    return (<>
        <section>
            <h5 className="fw-bold mb-3 fs-5"><FontAwesomeIcon icon={faArrowLeft} className="pointer" onClick={() =>Navigate(-1)} /> Schedule Appointment</h5>
            <div className="bg-grey mt-1">
                <p className="p-2 fs-6 fw-semibold"><FontAwesomeIcon icon={faCircleInfo} />&nbsp;If you need an appointment for the next 24hrs, please call us at (123) 123 1234.</p>
            </div>
            <Card style={{ minHeight: "80vh" }}>
                <p className="fw-bold fs-5">Verify your Personal Information</p>
                <div className="row justify-content-between">
                    <div className="col-3">
                        <p className="fw-bold ">Contact Information</p>
                    </div>
                    {!contact && <div className="col-3 text-end">
                        <p className="fw-bold fs-6 text-danger pointer" onClick={EditContact}>Edit <FontAwesomeIcon icon={faPenToSquare} /> </p>
                    </div>}
                </div>
                {contact == false && <Row justify={"space-around"}>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <h6 className="text-c fw-normal">Work Phone</h6>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <h6 className="text-c fw-normal">Email Address</h6>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                        <h6 className="text-c fw-normal">Address</h6>
                    </Col>
                </Row>}
                {
                    contact && <Row gutter={[20, 10]}>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Work Phone" required >
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Email Address" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Address" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                }
                <hr />
                <div className="row justify-content-between">
                    <div className="col-3">
                        <p className="fw-bold ">Details About Me</p>
                    </div>
                    {!details && <div className="col-3 text-end">
                        <p className="fw-bold fs-6 text-danger pointer" onClick={EditDetails}>Edit <FontAwesomeIcon icon={faPenToSquare} /> </p>
                    </div>}
                </div>
                {details == false && <Row justify={"space-around"}>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Preferred First Name</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Gender Identity</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Sexual Orientation</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Race</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Ethnic Background</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Religion</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Legal Sex</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Sex Assigned at Birth</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Marital Status</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Ethnicity</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal">Language</h6>
                    </Col>
                    <Col span={8}>
                        <h6 className="text-c fw-normal"></h6>
                    </Col>
                </Row>}

                {
                    details && <Row gutter={[20, 10]}>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Preferred First Name" required >
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Gender Identity" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Sexual Orientation" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Race" required >
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Ethnic Background" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Religion" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Legal Sex" required >
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Sex Assigned at Birth" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Marital Status" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Ethnicity" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col xl={8} lg={8} md={12} sm={20} xs={22}>
                            <Form layout="vertical">
                                <Form.Item label="Language" required>
                                    <Input size="large" className="rounded-0" />
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                }
                <Row justify={"end"} className="position-absolute " style={{bottom:"30px", right:"10px"}}>
                    <div>
                        <Space align="end">
                            <Button className="default text-black border btn px-3" size="large">Cancel</Button>
                            <Button className="primary btn px-3" size="large" onClick={() => Navigate("/appointments")}>Submit</Button>
                        </Space>
                    </div>
                </Row>

            </Card>
        </section>
    </>)
}
export default AppointmentDetailSchedule